import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { HeroSection, IntroSection, Timeline, ValuesSection } from './'

export function AboutPage() {
  const { t } = useTranslation('common')

  return (
    <>
      <SEO
        title={t('nav.about')}
        description={t('about.metaDescription')}
        type="website"
      />

      <HeroSection />
      <IntroSection />
      <Timeline />
      <ValuesSection />
    </>
  )
}
